import {
  TextBox as KendoTextInput,
  TextBoxChangeEvent,
  TextBoxProps,
} from '@progress/kendo-react-inputs';
import { FC, useCallback } from 'react';

const TextInput: FC<TextBoxProps> = ({ onChange, ...other }) => {
  const handleChange = useCallback(
    (event: TextBoxChangeEvent) => {
      if ((event.target.value as string)?.startsWith(' ')) {
        event.nativeEvent.preventDefault();
      } else {
        onChange?.(event);
      }
    },
    [onChange]
  );
  const preventDefault = useCallback((e: any) => {
    e.preventDefault();
  }, []);

  const stopPropagation = useCallback((e: any) => {
    e.stopPropagation();
  }, []);

  return (
    <span onDragStart={preventDefault} onDragOver={preventDefault} onClick={stopPropagation}>
      <KendoTextInput onChange={handleChange} {...other} size="small" />
    </span>
  );
};

export default TextInput;
